import React, {useEffect, useState} from 'react';
import firebaseUtil from '../data/FirebaseUtil';
import {useTranslation} from "react-i18next";
import app from "../authentication/firebaseStart";

export const SSOSettingsContext = React.createContext();

const generateClientID = (clientType) => {
    if (clientType !== null && clientType.length !== 0 && typeof (clientType) === 'string') {
        if (clientType === 'els' || clientType === 'dtc' || clientType === 'dtw') {
            return clientType + crypto.randomUUID();
        } else {
            return null;
        }
    }
}

export const SSOSettingsProvider = ({ children }) => {
    const [SSOSettings, setSSOSettings] = useState(null);
    const [pending, setPending] = useState(true);
    const [authSSOProvider,setAuthSSOProvider] = useState(null)
    const {t} = useTranslation()



    useEffect(()=>{
        getSettings();
    },[])

    useEffect(()=>{
        getSettings();  
    },[authSSOProvider])

    useEffect(() => {
        try {
            if (SSOSettings !== null) {
                
                if(app.auth().currentUser){
                    if (SSOSettings.webClientId === null || SSOSettings.webClientId === '') {
                        const clientID_DTW = generateClientID('dtw');
                        firebaseUtil.saveSSOSettings({
                            ...SSOSettings,
                            webClientId: clientID_DTW,
                        }).then(() => {
                                SSOSettings.webClientId = clientID_DTW;
                                getSettings();
                            }
                        )
                    }
                }  
            }
        } catch (e) {
            console.log("Error : ", e)
        }
    }, [SSOSettings])

    const getSettings= () =>{
        
        firebaseUtil.getSSOSettings(authSSOProvider).then(ssoSettingsResult => {
            if(authSSOProvider){
                console.log("came for get seting==============>",ssoSettingsResult)
                ssoSettingsResult = {...ssoSettingsResult, ssoProvider:authSSOProvider}
            }
            setSSOSettings(ssoSettingsResult);
            setPending(false);
        }).catch(err => {
            console.log("Error :", err);
        });
    }

    const refreshSSOSettings = () =>{
        getSettings();
    }

    if (pending) {
        return <>{t('loading__')}</>
    }

    return (
        <SSOSettingsContext.Provider value={{ SSOSettings, setSSOSettings, refreshSSOSettings,setAuthSSOProvider}}>
            {children}
        </SSOSettingsContext.Provider>
    );
}